// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { MrIconTooltip } from '@ion/components';

const tooltipMessage = 'This is an unmanaged integration';

export default function UnmanagedWarning() {
  return <MrIconTooltip message={tooltipMessage} />;
}
